import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import OptimizedImage from '../OptimizedImage';
import './UnifiedCard.sass';

const UnifiedCard = ({ 
  variant = 'property', // 'property', 'admin', 'info', 'search'
  image,
  title,
  description,
  price,
  url,
  onClick,
  loading = false,
  badge,
  rating,
  metadata,
  className = '',
  children // Para contenido personalizado
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const cardClasses = [
    'unified-card',
    `unified-card--${variant}`,
    loading && 'unified-card--loading',
    className
  ].filter(Boolean).join(' ');

  const CardContent = () => (
    <div className={cardClasses}>
      {/* Image Section */}
      {image && (
        <div className="unified-card__image-container">
          <OptimizedImage
            src={image.src}
            alt={image.alt || title}
            className="unified-card__image"
            onLoad={() => setImageLoaded(true)}
            priority={image.priority || false}
          />
          
          {/* Overlays */}
          {badge && (
            <div className="unified-card__badge">
              {badge}
            </div>
          )}
          
          {price && (
            <div className="unified-card__price-tag">
              {price}
            </div>
          )}
          
          {rating && (
            <div className="unified-card__rating">
              ⭐ {rating}
            </div>
          )}
          
          {/* Hover Effect */}
          <div className="unified-card__overlay">
            <div className="unified-card__overlay-content">
              <span className="unified-card__view-icon">👁️</span>
            </div>
          </div>
        </div>
      )}

      {/* Content Section */}
      <div className="unified-card__content">
        {title && (
          <h3 className="unified-card__title">{title}</h3>
        )}
        
        {description && (
          <p className="unified-card__description">{description}</p>
        )}
        
        {metadata && (
          <div className="unified-card__metadata">
            {metadata.map((item, index) => (
              <span key={index} className="unified-card__metadata-item">
                {item}
              </span>
            ))}
          </div>
        )}
        
        {children}
      </div>

      {/* Loading State */}
      {loading && (
        <div className="unified-card__loading">
          <div className="unified-card__skeleton">
            <div className="skeleton-line skeleton-line--title"></div>
            <div className="skeleton-line skeleton-line--text"></div>
            <div className="skeleton-line skeleton-line--text short"></div>
          </div>
        </div>
      )}
    </div>
  );

  // Conditional wrapper
  if (url) {
    return (
      <Link to={url} className="unified-card__link">
        <CardContent />
      </Link>
    );
  }

  if (onClick) {
    return (
      <button onClick={onClick} className="unified-card__button">
        <CardContent />
      </button>
    );
  }

  return <CardContent />;
};

export default UnifiedCard;